import React from 'react'
import Switch from 'react-bootstrap-switch'

import * as consultationService from '../services/consultation-service'
import * as scansService from '../services/scan-service'

import {EmailContext} from '../context/EmailContext'

import {replaceExpression} from '../utils'
import ConsultationModal from './ConsultationModal'
import ConsultationAnswerModal from './ConsultationAnswerModal'

import './react-bootstrap-switch.min.css'

export default class Collaboration extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.onToggleConsult = this.onToggleConsult.bind(this)
    this.onToggleCollaborators = this.onToggleCollaborators.bind(this)
    this.onToggleResponses = this.onToggleResponses.bind(this)
    this.onHideResponses = this.onHideResponses.bind(this)
    this.onCancelChangeCollaboration = this.onCancelChangeCollaboration.bind(this)
    this.updateCollaborators = this.updateCollaborators.bind(this)
    this.checkBoxFormatter = this.checkBoxFormatter.bind(this)
    this.changeCollaborator = this.changeCollaborator.bind(this)
    this.lastSavedStateCollaborators = this.lastSavedStateCollaborators.bind(this)
    this.state = {
      consult: false,
      preselected: props.collaborators.filter(c => c.selected === true).map(c => c.id).sort(),
      lastSavedStateCollaborators: props.collaborators.filter(c => c.selected === true).map(c => c.id).sort(),
      collaborators: props.collaborators,
      showConsultationModal: false,
      showResponsesModal: false,
      responses: []
    }
  }

  componentDidMount() {
    const initializePreexistingCollaboration = (consultationQuestions) => {
      const selectedConsultants = consultationQuestions.map(cq => cq.collaborator.id).sort()
      this.setState({
        ...this.state,
        consult: true,
        preselected: selectedConsultants,
        lastSavedStateCollaborators: selectedConsultants,
        collaborators: this.state.collaborators.map(c => ({...c, selected: selectedConsultants.indexOf(c.id) > -1}))
      })
    }

    if (this.props.isExtraQuestion) {
      if (this.props.data.length > 0) {
        if ('consultationQuestions' in this.props.data[0]) {
          const consultationQuestions = this.props.data[0].consultationQuestions
          if (consultationQuestions.length > 0) {
            initializePreexistingCollaboration(consultationQuestions)
          }
        }
      }
    }

    if ('consultationQuestions' in this.props.data) {
      const consultationQuestions = this.props.data.consultationQuestions
      if (consultationQuestions.length > 0) {
        initializePreexistingCollaboration(consultationQuestions)
      }
    }
  }

  getConsultNumber(option) {
    return option.total ? option.total : 0
  }

  getNumberOfConsultants() {
    return this.state.preselected.length
  }

  changeCollaborator(row, id) {
    this.setState({
      ...this.state,
      collaborators: this.state.collaborators.map(c => ({...c, selected: c.id === row.id ? !c.selected : c.selected}))
    })
  }

  onToggleConsult(e) {
    const scanId = this.props.scanId
    const newConsult = !this.state.consult
    let allRequests = []

    const buildPostData = (s, q, c) => {
      return {
        scanId: parseInt(s, 10),
        questionId: q,
        collaboratorIds: c
      }
    }

    if (newConsult) {
      if (this.props.isExtraQuestion) {
        const allQuestionIds = this.props.data.map(q => q.id)
        //obtain the initially selected collaborators and add them to each extra questions
        allRequests = allQuestionIds.map(qid => consultationService.setCollaboratorsQuestions(buildPostData(scanId, qid, this.state.preselected)))
        allRequests.push(...scansService.enableScanExtraQuestions(scanId))
      } else {
        //just do the current question
        allRequests.push(...consultationService.setCollaboratorsQuestions(buildPostData(scanId, this.props.data.id, this.state.preselected)))
      }
      //Do it
      Promise.all([allRequests]).then(() => {
        this.setState({
          ...this.state,
          collaborators: this.state.collaborators.map(c => ({
            ...c,
            selected: this.state.preselected.indexOf(c.id) > -1
          }))
        })
      })
    } else {
      //delete all the collaborations
      if (this.props.isExtraQuestion) {
        const allQuestionIds = this.props.data.map(q => q.id)
        allRequests = allQuestionIds.map(qid => consultationService.deleteCollaboratorQuestion(scanId, qid))
        allRequests.push(...scansService.disableScanExtraQuestions(scanId))
      } else {
        //just do the current question
        allRequests.push(...consultationService.deleteCollaboratorQuestion(scanId, this.props.data.id))
      }

      //Do the delete
      Promise.all([allRequests]).then(() => {
        this.setState({
          ...this.state,
          collaborators: this.props.collaborators
        })
      })

    }
    this.setState({
      ...this.state,
      consult: newConsult
    })
  }

  /*
  toggle the collaborators modal
   */
  onToggleCollaborators() {
    this.setState({
      ...this.state,
      showConsultationModal: true
    })
  }


  /*
  toggle the collaborators response modal on demand
   */
  onToggleResponses() {
    consultationService.getCollaboratorsResponses(this.props.scanId, this.props.data.id)
      .then((data) => {
          this.setState({
            ...this.state,
            responses: data,
            showResponsesModal: true
          })
        }
      )
  }

  lastSavedStateCollaborators() {
    return this.state.collaborators.filter(c => c.selected === true).map(c => c.id).sort()
  }

  onHideResponses() {
    this.setState({
      showResponsesModal: false
    })
  }

  /*
  Reset the collaborators to the initial state, toggle the collaborators modal
   */
  onCancelChangeCollaboration() {
    const selectedCollaborators = this.state.lastSavedStateCollaborators
    this.setState({
      ...this.state,
      preselected: selectedCollaborators,
      collaborators: this.props.collaborators.map(c => ({...c, selected: selectedCollaborators.indexOf(c.id) > -1})),
      showConsultationModal: false
    })
  }

  updateCollaborators() {
    let allRequests = []
    const selectedCollaborators = this.lastSavedStateCollaborators()
    const buildPostData = (s, q, c) => {
      return {
        scanId: parseInt(s, 10),
        questionId: q,
        collaboratorIds: c
      }
    }
    if (this.props.isExtraQuestion) {
      //for extra questions we do it for all que related extra questions
      const allQuestionIds = this.props.data.map(q => q.id)
      allRequests.push(...allQuestionIds.map(qid => consultationService.setCollaboratorsQuestions(buildPostData(this.props.scanId, qid, selectedCollaborators))))
    } else {
      //for the single question the consultation gets updated
      allRequests.push(...consultationService.setCollaboratorsQuestions(buildPostData(this.props.scanId, this.props.data.id, selectedCollaborators))
      )
    }
    Promise.all([allRequests]).then(() => {
      this.setState({
        ...this.state,
        preselected: selectedCollaborators,
        lastSavedStateCollaborators: selectedCollaborators,
        showConsultationModal: false
      })
    })
  }

  checkBoxFormatter(cell, row, id) {
    return (
      <div className="row-actions">
        <form>
          <div className="checkbox">
            <label>
              <input type="checkbox"
                     checked={row.selected}
                     onChange={() => this.changeCollaborator(row, id)}
                     disabled={!row.initiallySelected}/>
              <span className={row.initiallySelected ? 'text' : 'text disabled'}>&nbsp;</span>
            </label>
          </div>
        </form>
      </div>
    )
  }

  static headerFormatter(column, colIndex, {sortElement}) {
    return (
      <span className="sortable-inner" key={colIndex}>
        <span className="text">{column.text}</span>
        {sortElement}
      </span>
    )
  }

  static contentFormatter(cell, row) {
    return <span className={row.initiallySelected ? 'text' : 'text disabled'}>{cell}</span>
  }

  render() {
    const {data, answermap, isExtraQuestion} = this.props
    const {consult, collaborators, showConsultationModal, showResponsesModal, responses} = this.state
    const switchId = isExtraQuestion ? 'extra-questions' : 'consult' + data.questionNumber
    const dataId = isExtraQuestion ? 'extra-questions' : data.id

    return (
      <div className="col consultation">
        <div className="result-section">
          <EmailContext.Consumer>
            {context => {
              if (!context.state.shallActivateEmailButton && consult) {
                context.activatedEmailButton()
              }
              return (<Switch
                name={switchId}
                value={consult}
                key={switchId}
                disabled={!!context.state.isFeedbackSent}
                checked={consult}
                onText={''}
                offText={''}
                handleWidth={18}
                onChange={(e) => this.onToggleConsult(e)}
              />)
            }}
          </EmailContext.Consumer>
          {consult &&
          <div className="result-inner">
            <div className="result-container">
              {!isExtraQuestion &&
              <ul>
                {data.options.map(option => (
                  <li key={option.id}>
                    <span
                      className="number">{this.getConsultNumber(option)}&nbsp;&nbsp;/&nbsp;&nbsp;{this.getNumberOfConsultants()}</span>
                    <span className="text">{replaceExpression(option.optionText, answermap)}</span>
                  </li>
                ))}
              </ul>
              }
            </div>

            {!isExtraQuestion &&
            <div className="button-container">
              <ConsultationModal
                title={"Raadplegen medewerkers"}
                id={'q-' + dataId}
                keyfield={"Raadplegen" + dataId}
                data={collaborators}
                questionid={dataId}
                save={this.updateCollaborators}
                cancel={this.onCancelChangeCollaboration}
                triggercollaboratorsmodal={this.onToggleCollaborators}
                triggerresponsesmodal={this.onToggleResponses}
                checkboxformatter={(cell, row, id) => this.checkBoxFormatter(cell, row, id)}
                show={showConsultationModal}
              />
            </div>
            }

            {showResponsesModal &&
            <ConsultationAnswerModal
              title={"Antwoorden"}
              key={'ConsultationAnswerModal' + dataId}
              id={'a-' + dataId}
              keyfield={"Antwoorden" + dataId}
              data={data}
              answermap={answermap}
              responses={responses}
              collaborators={collaborators}
              cancel={this.onHideResponses}
              show={showResponsesModal}
            />
            }
          </div>
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Collaboration.js